/* SECCA — tema Shopify. El carrito es el real de Shopify (/cart.js), así que
   el checkout y los descuentos automáticos por cantidad funcionan de verdad. */

const FREE_SHIP = 170000;                 // en centavos: $1.700
const UPSELL_HANDLE = 'secca-plush';
const fmt = c => '$ ' + Math.round(c / 100).toLocaleString('es-UY');
const esc = s => String(s == null ? '' : s).replace(/[&<>"]/g, m => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[m]));

let CART = { items: [], total_price: 0, item_count: 0 };
let upsellProduct = null;

/* ================= Carrito ================= */
async function getCart() {
  CART = await (await fetch('/cart.js', { headers: { 'Accept': 'application/json' } })).json();
  renderCart();
  return CART;
}

/* Agrega varias lineas de una. Lo usa el pack de colores mezclados de la ficha:
   tres toallas de tres colores son tres lineas distintas, para que el stock de
   cada color se descuente donde va. Shopify lo trata como una sola operacion:
   si una linea no tiene stock no entra ninguna, y el carrito no queda a medias. */
async function addItems(items) {
  const r = await fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: JSON.stringify({ items })
  });
  if (!r.ok) {
    const e = await r.json().catch(() => ({}));
    toast(e.description || 'No se pudo agregar');
    return;
  }
  await getCart();
  const total = items.reduce((s, i) => s + (i.quantity || 1), 0);
  toast(total > 1 ? `${total} unidades agregadas` : 'Agregado al carrito');
  openDrawer();
}

async function addToCart(variantId, qty = 1) {
  return addItems([{ id: variantId, quantity: qty }]);
}

async function changeLine(line, quantity) {
  CART = await (await fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: JSON.stringify({ line, quantity })
  })).json();
  renderCart();
}

/* Lo que el cliente eligió unidad por unidad viaja como propiedades de la línea.
   Las que arrancan con guion bajo son internas y no se muestran. */
function propsHtml(it) {
  const props = Object.entries(it.properties || {}).filter(([k, val]) => k[0] !== '_' && val);
  if (!props.length) return '';
  return `<ul class="ci-props">${props.map(([k, val]) => `<li><b>${esc(k)}:</b> ${esc(val)}</li>`).join('')}</ul>`;
}

function renderCart() {
  const box = document.getElementById('cartItems');
  const cc = document.getElementById('cartCount');
  if (cc) { cc.style.display = CART.item_count ? 'grid' : 'none'; cc.textContent = CART.item_count; }
  if (!box) return;

  if (!CART.items.length) {
    box.innerHTML = `<div class="cart-empty">
      <svg fill="none" stroke="currentColor" stroke-width="1.5" viewBox="0 0 24 24"><path d="M6 7h12l1.2 12.2a1.6 1.6 0 0 1-1.6 1.8H6.4a1.6 1.6 0 0 1-1.6-1.8L6 7Z"/><path d="M9 10V6a3 3 0 0 1 6 0v4"/></svg>
      Tu carrito está vacío.<br>La Cenefa es la más elegida.</div>`;
  } else {
    box.innerHTML = CART.items.map((it, i) => {
      const desc = it.variant_title && it.variant_title !== 'Default Title' ? it.variant_title : '';
      const rebaja = it.original_line_price > it.final_line_price;
      return `<div class="cart-item">
        <a href="${it.url}"><img src="${it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/i, '_200x$1$2') : ''}" alt="" loading="lazy"></a>
        <div class="ci-info">
          <h4><a href="${it.url}">${esc(it.product_title)}</a></h4>
          <span class="ci-price">${desc ? esc(desc) + ' · ' : ''}${fmt(it.final_price)} c/u${rebaja ? ` <b class="ci-save">−${fmt(it.original_line_price - it.final_line_price)}</b>` : ''}</span>
          ${propsHtml(it)}
          <div class="ci-row">
            <div class="qty">
              <button data-line="${i + 1}" data-q="${it.quantity - 1}">−</button><span>${it.quantity}</span><button data-line="${i + 1}" data-q="${it.quantity + 1}">+</button>
            </div>
            <button class="ci-del" data-line="${i + 1}" data-q="0">Quitar</button>
          </div>
        </div>
      </div>`;
    }).join('');
  }

  const total = CART.total_price;
  const ahorro = CART.items.reduce((s, it) => s + (it.original_line_price - it.final_line_price), 0);
  const t = document.getElementById('cartTotal');
  if (t) t.textContent = fmt(total);

  const note = document.getElementById('minNote');
  if (note) {
    if (ahorro > 0) { note.innerHTML = `Ahorrás <b>${fmt(ahorro)}</b> con los descuentos por cantidad`; note.classList.add('show') }
    else note.classList.remove('show');
  }

  const fill = document.getElementById('shipFill');
  if (fill) fill.style.width = Math.min(100, total / FREE_SHIP * 100) + '%';
  const msg = document.getElementById('shipMsg');
  if (msg) msg.innerHTML = total >= FREE_SHIP
    ? '<b>Envío sin cargo a todo el país</b>'
    : total === 0
      ? `Envío sin cargo en pedidos desde <b>${fmt(FREE_SHIP)}</b>`
      : `Faltan <b>${fmt(FREE_SHIP - total)}</b> para el envío sin cargo`;

  renderUpsell();
}

/* Upsell del carrito: una sola oferta, la lisa, si todavía no está en el pedido. */
async function renderUpsell() {
  const box = document.getElementById('cartUpsell');
  if (!box) return;
  if (!CART.items.length) { box.innerHTML = ''; return }
  if (!upsellProduct) {
    try { upsellProduct = await (await fetch(`/products/${UPSELL_HANDLE}.js`)).json() } catch (e) { return }
  }
  const p = upsellProduct;
  const yaEsta = CART.items.some(i => i.handle === UPSELL_HANDLE);
  const v = (p.variants || []).find(x => x.available);
  if (yaEsta || !v) { box.innerHTML = ''; return }
  box.innerHTML = `<div class="up">
    <div class="up-head">Sumá a tu pedido</div>
    <div class="up-row">
      <img src="${p.featured_image}" alt="${esc(p.title)}" loading="lazy">
      <div class="up-txt">
        <b>${esc(p.title)}</b>
        <small>Lisa, sin relieve. La que mejor combina con todo.</small>
        <span class="up-price">${fmt(v.price)}</span>
      </div>
      <button class="up-btn" data-add="${v.id}">Agregar</button>
    </div>
  </div>`;
}

function openDrawer() { document.getElementById('drawer').classList.add('on'); document.getElementById('overlay').classList.add('on'); document.body.style.overflow = 'hidden' }
function closeDrawer() { document.getElementById('drawer').classList.remove('on'); document.getElementById('overlay').classList.remove('on'); document.body.style.overflow = '' }

/* ================= Toast ================= */
let toastT;
function toast(m) {
  const t = document.getElementById('toast');
  if (!t) return;
  document.getElementById('toastMsg').textContent = m;
  t.classList.add('on'); clearTimeout(toastT);
  toastT = setTimeout(() => t.classList.remove('on'), 2400);
}

/* ================= Anuncios y marquesina ================= */
function initAnnounce() {
  const el = document.getElementById('announce'); if (!el) return;
  const msgs = [
    'Envío <b>sin cargo</b> en compras desde <b>$1.700</b>',
    'Hasta <b>27% menos</b> llevando seis unidades',
    'Todas las toallas miden <b>90 × 160 cm</b>',
    'Entrega en <b>24 a 72 horas</b> hábiles por DAC'
  ];
  el.innerHTML = msgs.map((m, i) => `<div class="msg ${i === 0 ? 'on' : ''}"><span>${m}</span></div>`).join('');
  let i = 0; const spans = el.querySelectorAll('.msg');
  setInterval(() => { spans[i].classList.remove('on'); i = (i + 1) % spans.length; spans[i].classList.add('on') }, 4200);
}
function initMarquee() {
  const el = document.getElementById('marquee'); if (!el) return;
  const items = ['Todas de 90 × 160 cm', 'Secado súper rápido', 'Sin sol ni calefacción', 'Absorbe cuatro veces su peso', 'No suelta pelusa', 'Envío sin cargo desde $1.700'];
  const half = items.map(t => `<span>${t}</span>`).join('');
  el.innerHTML = half + half;
}

/* ================= Reveal ================= */
function initReveal() {
  const io = 'IntersectionObserver' in window
    ? new IntersectionObserver(es => es.forEach(e => { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target) } }), { rootMargin: '99999px 0px -8% 0px' })
    : null;
  if (io) document.querySelectorAll('.rv').forEach(el => io.observe(el));
  setTimeout(() => { if (!document.querySelector('.rv.in')) document.querySelectorAll('.rv').forEach(el => el.classList.add('in')) }, 1800);
}

/* ================= Boot ================= */
document.addEventListener('DOMContentLoaded', () => {
  initAnnounce(); initMarquee(); initReveal();

  const bc = document.getElementById('btnCart'); if (bc) bc.onclick = openDrawer;
  const dc = document.getElementById('drawerClose'); if (dc) dc.onclick = closeDrawer;
  const ov = document.getElementById('overlay'); if (ov) ov.onclick = closeDrawer;
  const bm = document.getElementById('btnMenu'); if (bm) bm.onclick = () => document.getElementById('mnav').classList.add('on');
  const mc = document.getElementById('mnavClose'); if (mc) mc.onclick = () => document.getElementById('mnav').classList.remove('on');
  document.addEventListener('keydown', e => { if (e.key === 'Escape') closeDrawer() });

  document.addEventListener('click', e => {
    const add = e.target.closest('[data-add]');
    if (add) { e.preventDefault(); addToCart(+add.dataset.add, +(add.dataset.qty || 1)); return }
    const ln = e.target.closest('[data-line]');
    if (ln) { e.preventDefault(); changeLine(+ln.dataset.line, +ln.dataset.q); return }
  });

  getCart();
  if (typeof pageInit === 'function') pageInit();
});
